import { render } from "./GrossScore.vue?vue&type=template&id=3834b362"
import script from "./GrossScore.vue?vue&type=script&lang=js"
export * from "./GrossScore.vue?vue&type=script&lang=js"
script.render = render

export default script